import React from 'react';

interface IProps {
  style?: any;
}

const CropIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 7.62014V5.76588H4.86744V0.898438H6.7217V5.76588H15.993V14.0869H14.1388V7.62014H0Z" fill="#CCCCCC"/>
        <path d="M20.8604 15.0371V16.8913H15.993V21.7588H14.1387V16.8913H4.86743V8.57031H6.72169V15.0371H20.8604Z" fill="#CCCCCC"/>
    </svg>
  )
}

export default CropIcon;